<template>
  <div class="px-10 py-4 md:px-8 sm:px-6">
    <w-button
      class="wrapper__go-back"
      type="text"
      @click="goBack"
    >
      <i class="icon-chevron-left-bold" />
      返回一起訂東西
    </w-button>
    <div class="flex flex-wrap gap-x-4 gap-y-2 items-baseline mb-12">
      <h1 class="flex-shrink-0 text-2xl text-black">例行性訂購排程</h1>
    </div>
    <div class="bg-white p-4">
      <schedule-search
        v-model="search"
        :dates="dates"
        :date-type="dateType"
        :loading="loading"
        @clear="onClearSearch"
        @search="onSearch"
        @updated-dates="onDatesUpdates"
        @updated-date-type="onDateTypeUpdated"
      />
      <div class="flex flex-wrap gap-4 items-center justify-between mb-6">
        <div></div>
        <div class="flex gap-6">
          <w-button :disabled="loading" size="sm" @click="onCreateNew">
            <i class="icon-plus" />
            <span class="ml-2">建立例行性訂購排程</span>
          </w-button>
        </div>
      </div>
      <schedule-list
        :current-page="page"
        :current-per-page="perPage"
        :current-tab="currentTab"
        :loading="loading"
        :schedules="schedules"
        :sort-field="sortField"
        :sort-order="sortOrder"
        @sort="onSort"
      />
      <div v-if="total && !loading" class="flex gap-4 items-center">
        <b-select v-model="perPage">
          <option
            v-for="option in perPageOptions"
            :value="option.value"
            :key="option.label"
          >
            {{ option.label }}
          </option>
        </b-select>
        <div class="flex-grow">
          <b-pagination
            :total="total"
            v-model="page"
            range-before="3"
            range-after="1"
            nextIcon="right-chevron"
            prevIcon="left-chevron"
            :per-page="perPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Schedule from './Schedule';

export default Schedule;
</script>

<style lang="scss" scoped>
@import './Schedule';
</style>
